
const maxDepth = 8

function interpolate (a, b, ratio) {
    return rawInterpolate(a, b, ratio, -1)
}


function remap (value, {start = 0, end = 1, clamp = true, easing} = {}) { //eslint-disable-line complexity
    let ratio = (value - start) / (end - start)

    if (easing || clamp) {
        ratio = Math.max(Math.min(ratio, 1), 0)
    }

    if (easing === "easeIn") {
        return ratio * ratio
    } else if (easing === "easeOut") {
        return ratio * (2 - ratio)
    } else if (easing === "easeInOut") {
        return ratio * ratio * (3 - 2 * ratio) //smoothstep
    }

    return ratio
}

interpolate.remap = remap



function closestEndValueWithModulo ({start, end, modulo}) {
    let delta = (end - start) % modulo
    delta = (delta + modulo) % modulo
    if (delta > modulo / 2) {
        delta -= modulo
    }
    return start + delta
}

interpolate.closestEndValueWithModulo = closestEndValueWithModulo




function rawInterpolate (a, b, ratio, depth) { //eslint-disable-line complexity
    let type = (typeof a)
    if (type !== typeof b) {
        type = "different"
    }
    if (type === "number") {
        return interpolateNumber(a, b, ratio)
    } else if (type === "object" && depth < maxDepth) {
        if (Array.isArray(a)) {
            return interpolateArray(a, b, ratio, depth + 1)
        } else {
            return interpolateObject(a, b, ratio, depth + 1)
        }
    } else if (ratio < 0.5) {
        return a
    } else {
        return b
    }
}



function interpolateObject (objectA, objectB, ratio, depth) {
    let result = {}
    let nextDepth = depth + 1
    for (let key in objectA) {
        result[key] = rawInterpolate(objectA[key], objectB[key], ratio, nextDepth)
    }
    for (let key in objectB) {
        if (!(key in objectA)) {
            result[key] = rawInterpolate(undefined, objectB[key], ratio, nextDepth)
        }
    }
    return result
}


function interpolateArray (arrayA, arrayB, ratio, depth) {
    let nextDepth = depth + 1

    let count = (ratio < 0.5 ? arrayA.length : arrayB.length)

    const result = new Array(count)
    for (let index = 0; index < count; index++) {
        result[index] = rawInterpolate(arrayA[index], arrayB[index], ratio, nextDepth)
    }
    return result
}


function interpolateNumber (numberA, numberB, ratio) {
    return numberA + (numberB - numberA) * ratio
}


export default interpolate

